import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import httpCommonHeaders from './httpCommonHeaders';

const WALLET_TIMEOUT = 40_000;

const walletService = {};

walletService.getWallet = () => {
  return axios(
    `${process.env.NEXT_PUBLIC_LEGACY_API}/user/wallet`,
    {
      cache: false,
      headers: httpCommonHeaders(),
      method: 'GET',
      timeout: WALLET_TIMEOUT,
      withCredentials: true,
    },
    WALLET_TIMEOUT,
  );
};

export default walletService;
